export default function validationRegroupementInformation(
  lignesCommandes, messages, ligneSelected,
) {
  const hasProductWithNoId = [];
  lignesCommandes.forEach((ligne) => {
    if (!ligne.produitId && ligne.selected) hasProductWithNoId.push(ligne);
  });
  if (hasProductWithNoId.length > 0 && ligneSelected.length === 0) {
    messages.push({
      message: 'ligneRegroupementPersonnalisee.erreur.produitWhithProductId',
    });
    return true;
  }
  if (ligneSelected.length === 0) {
    messages.push({
      message: 'ligneRegroupementPersonnalisee.erreur.atLeastOneSelected',
    });
    return true;
  }
  return false;
}
